import Vue from 'vue'
import request from '@/helpers/request'

export default {
  GET_COUNTRIES: ({ commit, state }, params) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.countries.all}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      const data = response.data.data
      commit('setCountries', state.countries.concat(data.items))
    })
  },
}
